import { html } from "lit";
import { TemplateResult } from "lit-html";
import { customElement, property } from "lit/decorators.js";
import BaseInput from "./BaseInput";

@customElement("basic-textarea")
class BasicTextArea extends BaseInput {
	@property({ type: String }) placeholder = "Hier Text eingeben...";
	@property({ type: Number }) rows = 4;

	protected renderInput(): TemplateResult {
		return html`
            <textarea
                id="${this.id}"
                name="${this.name}"
                placeholder="${this.placeholder}"
                rows="${this.rows}"
				.value="${this.value}"
            ></textarea>
        `;
	}
}

export default BasicTextArea;